module.exports = __webpack_public_path__ + "img/wm4.7ae1cae5.png";